import { forwardRef } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { Icone } from './Icone.js'

/**
 * Variantes:
 *  primario   — laranja cheio com texto PRETO (5.82:1). Branco sobre laranja
 *               reprovaria em corpo de botão, que não é display.
 *  secundario — contorno, para ação não destrutiva
 *  ghost      — sem peso, para ação terciária
 *  pilula     — "Botão de chamada · pílula" do guia; é o do WhatsApp
 *  perigo     — cancelar pedido, excluir
 *
 * Alvo de toque mínimo de 44px em todos os tamanhos: a cozinha usa tablet com
 * a mão engordurada, e o cliente usa o celular andando.
 */
export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: 'primario' | 'secundario' | 'ghost' | 'pilula' | 'perigo' | undefined
  tamanho?: 'sm' | 'md' | 'lg' | undefined
  icone?: LucideIcon | undefined
  iconeDireita?: LucideIcon | undefined
  carregando?: boolean | undefined
  larguraTotal?: boolean | undefined
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variante = 'primario',
    tamanho = 'md',
    icone,
    iconeDireita,
    carregando,
    larguraTotal,
    children,
    className,
    disabled,
    ...resto
  },
  ref,
) {
  const px = tamanho === 'sm' ? 16 : tamanho === 'lg' ? 24 : 20
  return (
    <button
      ref={ref}
      type={resto.type ?? 'button'}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      className={cn(
        'du-botao',
        `du-botao--${variante}`,
        `du-botao--${tamanho}`,
        larguraTotal && 'du-botao--cheio',
        className,
      )}
      {...resto}
    >
      {carregando ? (
        <span className="du-botao__girando" aria-hidden />
      ) : icone ? (
        <Icone de={icone} tamanho={px} />
      ) : null}
      <span className="du-botao__rotulo">{children}</span>
      {iconeDireita && !carregando ? <Icone de={iconeDireita} tamanho={px} /> : null}
    </button>
  )
})
